import { createFileRoute } from '@tanstack/react-router'
import Banner from '@/components/banner'
import { Mail, MessageSquare } from '@/components/svg'

export const Route = createFileRoute('/contact')({
  component: RouteComponent,
})

const contacts = [
  {
    title: 'Customer Service',
    icon: <MessageSquare size={80} />,
    content: (
      <>
        <a href="tel:1300443735">{SUPPORTPHONE}</a> (8:30am – 5:00pm AEST Monday
        - Friday)
        <a href={`mailto:${SUPPORTEMAIL}`}>{SUPPORTEMAIL}</a>
      </>
    ),
  },
  {
    title: 'Broadband Technical Support',
    icon: <Mail size={80} />,
    content: (
      <>
        <a href="tel:1300443735">{SUPPORTPHONE}</a> (24/7 Monday - Sunday)
        <a href={`mailto:${SUPPORTEMAIL}`}>{SUPPORTEMAIL}</a>
      </>
    ),
  },
]

function RouteComponent() {
  return (
    <>
      <Banner
        backgroundUrl="/img/contact_us.png"
        containerStyle="min-h-[450px] lg:min-h-[550px]"
      />

      <div className="breakpoint-container px-0 md:px-4 -mt-[210px] z-10 mb-20">
        <h1 className="text-6xl text-white font-bold mb-15 px-4 md:px-0">
          Contact Us
        </h1>
        <div className="card-row-container flex-wrap md:flex-nowrap">
          {contacts.map((data, index) => (
            <div className="card items-center w-full" key={index}>
              {data.icon}

              <h2 className="text-3xl font-bold mb-5 mt-2 whitespace-pre-line">
                {data.title}
              </h2>

              {data.content}
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
